import { prop } from 'ramda';

import { clear, unprefix } from '../../../../helpers/compact';
import { MEDIA_TYPE } from '../../../../types/press-media';
import { CommonSliceType } from '../../../../types/slice';
import { toFormat } from '../../mapping/format';
import { toPosition } from '../../mapping/position';
import { toSize } from '../../mapping/size';
import { image } from '../../partials/image';
import { quote } from '../../partials/quote';

export const imageSlice = ({ primary }) => {
  const normalizedImage = image(primary);

  if (normalizedImage) {
    const size = toSize(prop('size', primary));
    return clear({
      type: CommonSliceType.IMAGE_N_CAPTION,
      size,
      position: size === 'small' ? toPosition(prop('position', primary)) : null,
      format: size === 'small' ? toFormat(prop('format', primary)) : null,
      ...normalizedImage,
    });
  }
};

export const imageWithQuoteSlice = ({ primary }) => {
  const normalizedImage = image(primary);
  const normalizedQuote = quote(unprefix('image', primary));

  if (normalizedImage && normalizedQuote) {
    const { position, ...normalizedQuoteRest } = normalizedQuote;
    return clear({
      type: CommonSliceType.IMAGE_N_QUOTE,
      media: normalizedImage,
      mediaType: MEDIA_TYPE.PHOTO,
      quote: normalizedQuoteRest,
      position,
    });
  }
};

export const imageWithTextSlice = ({ primary }) => {
  const normalizedImage = image(primary);

  if (normalizedImage) {
    return clear({
      type: CommonSliceType.IMAGE_N_TXT,
      media: normalizedImage,
      mediaType: MEDIA_TYPE.PHOTO,
      text: prop('txt', primary),
    });
  }
};
